import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, startWith, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { BaseChipComponent } from '../../base-chip/base-chip.component';
import { ChipInputSearchHelper } from '../../helpers/chip-input-search.helper';
import {
  DateChipPickerMode,
  DateChipProperties,
} from '../../types/chip-properties/date';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'cis-date-chip-search-filter',
  templateUrl: './date-chip-search-filter.component.html',
  styleUrls: ['./date-chip-search-filter.component.scss'],
})
export class DateChipSearchFilterComponent
  extends BaseChipComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('input') chipInput?: ElementRef<HTMLInputElement>;
  date = new FormControl();
  pickerMode: DateChipPickerMode = 'year-month-date';
  openPicker = new Subject<void>();

  get selectedDataChipProperties(): DateChipProperties | undefined {
    return this.selectedData?.chipProperties as DateChipProperties;
  }

  constructor(chipInputSearchHelper: ChipInputSearchHelper) {
    super(chipInputSearchHelper);
    this.date.valueChanges
      .pipe(startWith(''), debounceTime(200))
      .subscribe((chipValue) => {
        if (this.selectedDataChipProperties) {
          this.selectedDataChipProperties.value = chipValue?.toString();
        }
        this.editedData.emit(this.selectedData);
      });
  }

  ngOnInit(): void {
    this.date.setValue(this.selectedDataChipProperties?.value);
    this.minWidth = this.selectedData?.size || this.minWidth;
    this.date.valueChanges
      .pipe(debounceTime(50), takeUntil(this.onDestroy$))
      .subscribe(() => {
        this.formControl = this.date;
        this.value = this.date.value;
        if (this.selectedData?.validations) {
          super.validate_value();
        }
        super.resize(this.minWidth);
      });

    this.formControl = this.date;
    this.value = this.date.value;

    super.resize(this.minWidth);

    this.pickerMode =
      (this.selectedData?.chipProperties as DateChipProperties).properties
        ?.pickerMode ?? this.pickerMode;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (!this.isChipLock) {
        this.chipInput?.nativeElement.focus();
      }
    }, 10);
  }

  ngOnDestroy() {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
